var exports = {
  "p": "x31de4314--c5aa25--list",
};

module.exports = exports;
